<template>
	<div class="modal-credits">
		<div class="bg" v-tap="close"></div>
		<div class="content">
			<div class="title">Crédits</div>
			<div class="main-text" v-html="modal?.props?.credits"></div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		modal: { type: Object, required: true },
	},
	methods: {
		close() {
			this.$emit('close')
		}
	}
}
</script>

<style lang="stylus" scoped>
.modal-credits
	display block
	.bg
		absolute 0
	> .content
		max-width calc(100dvw - 64px)
		width 800px
		padding 32px
		background-color #eee
		border-radius 24px
		color dark-blue
		font-size 2rem
		text-align center
		.title
			border-bottom 2px solid dark
			font-size 3.2rem
			font-weight 500
			text-transform uppercase
		.main-text
			overflow-y scroll
			padding-top 24px
			max-height 75dvh
	p
	::v-deep(strong)
		text-transform uppercase
		color theme-light-blue

@media (max-width: 500px)
	.modal-credits
		> .content
			padding 16px
			max-width calc(100dvw - 48px)

</style>
